import React from 'react'
import VerificationCodeTemplate from '../../../Templates/Auth/ForgotPassword/VerificationCode.template'

function VerificationCodePage() {
  return (
    <VerificationCodeTemplate />
  )
}

export default VerificationCodePage